<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Генератор QR

  .container.mt-5
    .row.white_block
      .col-sm-8
        .inputModule
          input-module(type="link", title="Ссылка в QR коде", v-model="link") 
        .inputModule
          input-module(
            type="checkbox",
            title="Подключить статистику и уменьшить ссылку",
            label="Включить",
            v-model="use_sl",
            :disabled="sl ? false : true",
            :about="sl ? 'У Вас подключен сервис ShortLink, это позволит оптимизировать QR-код и считать переходы.' : 'Функция отключена. Чтобы её активировать, подключите сервис ShortLink.'"
          ) 
        .inputModule
          input-module(
            type="checkbox",
            title="UTM-метка QR-кода",
            label="Добавить метку",
            v-model="add_utm",
            about="UTM-метка позволит Вам легче распознать пользователя, который перейдет на сайт. Используется для маркетинговых инструментов."
          ) 
        .inputModule
          input-module(
            type="color",
            title="Цвет заднего фона",
            v-model="bg_color"
          ) 
        .inputModule
          input-module(type="color", title="Цвет кода", v-model="dot_color") 
        button.styled(
          :disabled="link == '' || !link.includes('http') || link.includes(' ') || loading",
          @click="getQR"
        ) Сгенерировать QR
      .col-sm-4.text-right
        .qr_image(:style="{ backgroundImage: `url(${qr_image})` }")
          .loader_holder(v-if="loading")
            object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
        br
        a.download(
          :href="qr_image ? qr_image : '#'",
          :download="qr_image ? 'qr.png' : false",
          :disabled="!qr_image"
        ) 
          <i class="fal fa-download"></i> 
          | Скачать
  .container.mt-5
    .row(v-if="history_loading")
      .col
        .loader_holder(style="text-align: center")
          object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
    .row(v-if="!history_loading && history.length != 0")
      .col-sm-3.history(v-for="qr of history")
        .white_block
          a.link(:href="qr.link", target="_blank") {{  qr.link.replace("http://",'').replace("https://",'')  }}
          .qr_image(:style="{ backgroundImage: `url(${qr.base64})` }")
          a.download(
            :href="qr.base64 ? qr.base64 : '#'",
            :download="qr.base64 ? 'qr.png' : false",
            :disabled="!qr.base64"
          ) 
            <i class="fal fa-download"></i> 
            | Скачать
          .date {{ qr.created }}
</template>
<script>
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {},

  data() {
    return {
      link: "",
      qr_image: "",
      add_utm: 1,
      use_sl: 0,
      sl: false,
      loading: false,
      bg_color: "#fff",
      dot_color: "#000",
      history: [],
      history_loading: true,
    };
  },

  computed: {},

  mounted() {
    let subscriptions = this.$store.state.userData.subscriptions;
    let sl = subscriptions.find((x) => x.service_id == 8);
    if (sl) this.sl = true;
    if (sl) this.use_sl = 1;
    this.getHistory();

    if (this.$route.query.link) {
      this.link = this.$route.query.link;
      this.use_sl = 0;
      this.add_utm = 0;
    }
  },

  methods: {
    async getSL(link) {
      let name = `QR на ` + new URL(link).hostname;
      let sl = (
        await apiDriver.services.api.post("sl", "create", { link, name })
      ).data.sl;
      return sl;
    },
    async getQR() {
      let disabled =
        this.link == "" ||
        !this.link.includes("http") ||
        this.link.includes(" ") ||
        this.loading;
      if (disabled) return;
      this.loading = true;
      let link = this.link;
      if (this.add_utm == 1) link = this.addUTM(link);
      if (this.use_sl == 1) link = await this.getSL(link);
      let qr = (
        await apiDriver.services.api.post("qr", "create", {
          link,
          bg_color: this.bg_color,
          dot_color: this.dot_color,
        })
      ).data;
      this.qr_image = qr;
      this.getHistory();
      this.loading = false;
    },
    addUTM(link) {
      if (link.includes("utm_source")) return link;
      if (link.includes("?")) {
        return (link += "&utm_source=qr");
      } else {
        return (link += "?utm_source=qr");
      }
    },
    async getHistory() {
      this.history_loading = true;
      let history = (await apiDriver.services.api.get("qr", "history")).data;
      for (let qr of history)
        qr.created = moment(qr.createdAt).format("DD.MM.YYYY HH:mm");
      this.history = history;
      this.history_loading = false;
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.inputModule {
  margin-bottom: 10px;
}

.qr_image {
  background-color: #eee;
  height: 200px;
  width: 200px;
  border-radius: 15px;
  display: inline-block;
  background-size: 92%;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;

  .loader_holder {
    object {
      width: 140px;
      margin: 0 auto;
      display: block;
      margin-top: 30px;
    }
  }
}

.download {
  border: none;
  background: none;
  width: 200px;
  opacity: 0.5;
  color: black;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
  margin: 0 auto;
  display: inline-block;

  &:hover {
    opacity: 1;
  }

  &[disabled] {
    cursor: default;
    opacity: 0.3;
  }
}

.history {
  a {
    display: block;
    text-align: center;
    font-weight: 400;
    font-size: 10pt;
    color: gray;

    &:hover {
      color: black;
    }
  }

  .qr_image {
    margin: 10px auto;
    display: block;
  }

  .date {
    text-align: center;
    font-size: 10pt;
    margin-top: 10px;
    color: #d4d4d4;
  }
}

@media only screen and (max-width: 600px) {
  .qr_image {
    margin-top: 20px;
    display: block;
  }

  .download {
    display: block;
  }
}

@media (prefers-color-scheme: dark) {
  .qr_image {
    background-color: #333;
  }

  .history a {
    color: #ffffff;

    &:hover {
      color: #ffffff;
    }
  }

  .download {
    color: #ffffff;
  }
}
</style>
